import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MeasurementSystem } from "../types/measurementSystems";

export type RegionMetadataSlice = {
  loading: boolean;
  enablePercentageAmi: boolean | null;
  id: number | null;
  isMetric: boolean | null;
  northeastBoundLatitude: unknown;
  northeastBoundLongitude: unknown;
  regionId: number | null;
  residentialVacancyRate: number | null;
  southwestBoundLatitude: unknown;
  southwestBoundLongitude: unknown;
  systems: string[] | null;
  modelMeasurementSystem: MeasurementSystem | null;
  modelMeasurementSystemId: number | null;
};

const initialState: RegionMetadataSlice = {
  loading: false,
  enablePercentageAmi: null,
  id: null,
  isMetric: null,
  northeastBoundLatitude: null,
  northeastBoundLongitude: null,
  regionId: null,
  residentialVacancyRate: null,
  southwestBoundLatitude: null,
  southwestBoundLongitude: null,
  systems: null,
  modelMeasurementSystem: null,
  modelMeasurementSystemId: null
};

const regionMetadataSlice = createSlice({
  name: "regionMetadata",
  initialState,
  reducers: {
    // NOTE: This action is unused
    startGetRegionMetadata(state) {
      state.loading = true;
      state.enablePercentageAmi = null;
      state.id = null;
      state.isMetric = null;
      state.northeastBoundLatitude = null;
      state.northeastBoundLongitude = null;
      state.regionId = null;
      state.residentialVacancyRate = null;
      state.southwestBoundLatitude = null;
      state.southwestBoundLongitude = null;
      state.systems = null;
      state.modelMeasurementSystem = null;
      state.modelMeasurementSystemId = null;
    },
    getRegionMetadataSuccess(state, action: PayloadAction<Record<string, any>>) {
      state.loading = false;
      state.enablePercentageAmi = action.payload.enablePercentageAmi;
      state.id = action.payload.id;
      state.isMetric = action.payload.isMetric;
      state.northeastBoundLatitude = action.payload.northeastBoundLatitude;
      state.northeastBoundLongitude = action.payload.northeastBoundLongitude;
      state.regionId = action.payload.regionId;
      state.residentialVacancyRate = action.payload.residentialVacancyRate;
      state.southwestBoundLatitude = action.payload.southwestBoundLatitude;
      state.southwestBoundLongitude = action.payload.southwestBoundLongitude;
      state.systems = action.payload.systems;
      state.modelMeasurementSystem = action.payload.modelMeasurementSystem;
      state.modelMeasurementSystemId = action.payload.modelMeasurementSystemId;
    },
    getRegionMetadataFailure(state) {
      state.loading = false;
      state.enablePercentageAmi = null;
      state.id = null;
      state.isMetric = null;
      state.northeastBoundLatitude = null;
      state.northeastBoundLongitude = null;
      state.regionId = null;
      state.residentialVacancyRate = null;
      state.southwestBoundLatitude = null;
      state.southwestBoundLongitude = null;
      state.systems = null;
      state.modelMeasurementSystem = null;
      state.modelMeasurementSystemId = null;
    }
  }
});

export const { getRegionMetadataSuccess, getRegionMetadataFailure } = regionMetadataSlice.actions;

export default regionMetadataSlice.reducer;
